import {makeStyles} from '@mui/styles';

export const useSepsisFromStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginTop: -6,
        padding: 10,
    },
    backgroundModal: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        opacity: '0.7',
        zIndex: 99,
    },
    closeIcon: {
        position: 'absolute',
        right: '3px',
        top: '4px',
    },
    checked: {
        background: '#69BB69',
        padding: '10px 20px',
        maxWidth: '280px',
        borderRadius: '10px',
        backgroundColor: theme.palette.background.paper,
        marginTop: 20,
    },
    checkedName: {
        fontWeight: 'bold',
    },
    checkedBody: {
        height: '62px',
        display: 'table-cell',
        verticalAlign: 'middle',
        borderRadius: '10px',
        backgroundColor: theme.palette.background.paper,
    },
    switchBox: {
        flexBasis: 'content',
        minWidth: '220px',
        maxWidth: '220px',
    },
    required: {
        width: '100%',
        height: '100%',
    },
    checkBtn: {
        width: '66%',
        height: '35px',
        background: '#C33131',
        display: 'inline-block',
        textAlign: 'center',
        lineHeight: '35px',
    },
    naBtn: {
        width: '34%',
        height: '35px',
        background: '#FFA500',
        display: 'inline-block',
        textAlign: 'center',
        lineHeight: '35px',
    },
    activeBtn: {
        cursor: 'pointer',
    },
    timer: {
        marginTop: 5,
        marginRight: 10,
        height: '35px',
        lineHeight: '25px',
        textAlign: 'center',
        maxWidth: 'min-content',
    },
    notRequired: {
        background: '#FFA500',
        textAlign: 'center',
        padding: '10px 20px',
        maxWidth: '280px',
        borderRadius: '10px',
        backgroundColor: theme.palette.background.paper,
    },
    footer: {
        width: '100%',
        marginTop: '40px',
    },
    fullWidth: {
        width: '100%',
    },
    cancel: {
        background: 'indianred',
        color: 'white',
    },
    pathwayRow: {
        height: '90px',
        marginBottom: '10px',
        display: 'flex',
    },
    pathwayTitle: {
        display: 'inline-flex',
        height: '100%',
        width: 'calc(100% - 280px)',
    },
    pathwayActions: {
        width: '100%',
        maxWidth: '210px',
        marginTop: '5px',
        marginBottom: '5px',
        display: 'flex',
        marginRight: 15,
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
    },
    headerTitle: {
        textAlign: 'center',
        padding: '10px 25px',
        fontSize: '22px',
        backgroundColor: theme.palette.background.paper,
        marginBottom: '15px',
        borderRadius: '10px',
    },
    headerSubtitle: {
        fontSize: '16px',
        padding: '5px 25px',
        marginTop: '-10px',
        backgroundColor: '#a1a1a1',
    },
    pathNumber: {
        backgroundColor: theme.palette.mode === 'dark' ? '#FFFFFF' : '#bfc2c7',
        color: '#222425',
        fontWeight: 'bold',
        fontSize: 16,
        borderRadius: 6,
        width: 40,
        height: 40,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    pathDescription: {
        paddingLeft: '15px',
        paddingRight: '15px',
        display: 'inline-block',
    },
    subjectBox: {
        display: 'flex',
        alignItems: 'flex-start',
        paddingLeft: 10,
        paddingTop: 10,
    },
    subject: {
        fontSize: '16px',
        fontWeight: '500',
        marginLeft: 10,
    },
    reasonModal: {
        width: '400px',
        background: theme.palette.background.default,
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: '10px 20px',
        marginTop: 'calc(50vh - 100px)',
    },
    reasonTexField: {
        width: '100%',
    },
    neuroSepsis: {
        background: '#FFA500',
        color: '#333',
        textAlign: 'center',
    },
    neuroWarning: {
        marginTop: 10,
        padding: 5,
        textAlign: 'center',
        color: '#333',
        background: '#dd7e6b',
        fontWeight: 'bold',
        fontSize: 'larger',
    },
    tep: {
        background: theme.palette.background.default,
        paddingBottom: 10,
        marginLeft: 16,
    },
    paedsAdditionalInfo: {
        background: '#C33131',
        color: '#FFFFFF',
        textAlign: 'center',
        paddingTop: '5px',
        paddingBottom: '5px',
        borderRadius: '10px',
        marginBottom: '10px',
    },
    infoBox: {
        background: '#ffd966',
        marginTop: 10,
        padding: 5,
        paddingLeft: 15,
        borderRadius: 8,
        fontWeight: 'bold',
        color: 'black',
    },
    infoBoxTitle: {
        borderBottom: `1px solid ${theme.palette.background.paperHover}`,
        paddingLeft: '10px',
        fontWeight: 'bold',
    },
    infoBoxRow: {
        paddingLeft: '10px',
        paddingRight: '10px',
    },
    infoBoxBullet: {
        fontSize: '24px',
    },
    sepsisRow: {
        width: '100%',
        background: theme.palette.background.paperDarker,
        borderRadius: 8,
        padding: 20,
        boxShadow: `0px ${theme.palette.mode === 'light' ? 4 : 0}px ${theme.palette.mode === 'light' ? 4 : 0}px 0px rgba(0, 0, 0, 0.25)`,
    },
    sepsisRowInfoBox: {
        margin: '15px 0',
        borderRadius: 8,
        border: `1px solid ${theme.palette.mode === 'dark' ? '#626466' : '#D2D5D9'}`,
        backgroundColor: theme.palette.mode === 'dark' ? '#3D3E40' : '#EFF1F3',
        padding: 5,
        width: 'fit-content',
    },
    reassessRow: {
        padding: '10px',
        background: theme.palette.background.paperDarker,
        borderRadius: '10px',
        justifyContent: 'space-between',
    },
    reassessCheckboxSection: {
        flexBasis: 'content',
        marginRight: '20px',
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    headerButtons: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginTop: 7,
        marginBottom: 7,
        paddingRight: 8,
        paddingBottom: 5,
    },
    sepsisTitle: {
        fontWeight: 'bold',
        fontSize: 16,
    },
    sepsisCreator: {
        fontSize: 12,
        marginLeft: 45,
        color: theme.palette.admissionForm.textColor,
    },
    divider: {
        margin: 5,
        width: '100%',
    },
    backButton: {
        marginRight: 5,
        backgroundColor: theme.palette.mode === 'dark' ? '#313233' : '#DEE1E5',
    },
    sepsisToggle: {
        padding: 12,
        '&.border': {
            borderRadius: 6,
            backgroundColor: theme.palette.mode === 'dark' ? '#222425' : '#DEE1E5',
        },
    },
    toggleRoot: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#EFF1F3' : '#494B4C',
        color: theme.palette.mode === 'light' ? '#ACAFB3' : '#2180F7',
    },
    toggleSelect: {
        '&&': {
            backgroundColor: '#2180F7',
            color: theme.palette.mode === 'light' ? '#FFF' : '#313233',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#2180F7',
                color: theme.palette.mode === 'light' ? '#FFF' : '#313233',
            },
        },
        '&.Mui-disabled': {
            backgroundColor: '#929292',
            border: 'none',
        },
    },
    toggleText: {
        marginTop: 10,
        fontSize: 14,
        color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#4f4d4d',
    },
    rows: {
        gap: 10,
        paddingTop: 16,
    },
}));